(function () {
  'use strict';

  var id = "activity";
  angular.module('wsLrs.cards').factory(id + ".ActivityCardResource", ["Api", "CardQueryResource", "Resource", "$http", function (Api, CardQueryResource, Resource, $http) {
    var templates = [{
      name: "card",
      path: "card",
      previewPath: "card/preview"
    }, {
      name: "overview",
      path: "overview",
      previewPath: "overview/preview"
    }, {
      name: "questions",
      path: "questions",
      previewPath: "questions/preview"
    }, {
      name: "timeline",
      path: "timeline",
      previewPath: "timeline/preview"
    }, {
      name: "groups",
      path: "",
      resource: "/groups",
      sharePath: true,
      crudResource: true
    }, {
      name: "count",
      path: "count",
      previewPath: "count/preview"
    }];
    return function endpoints(cardToPreview) {
      var self = _.object(_.map(templates, function (t) {
        var resourcePath = t.resource ? t.resource : "/activity/";
        var path = cardToPreview ? t.previewPath : t.path;
        var resource = new Resource(resourcePath + path, false, t.sharePath);

        // For all report resources, defer to CardQueryResource to do the actual fetching
        if (!t.crudResource) {
          resource.get = function (id, cfg) {
            return CardQueryResource.get({
              path: resource.__apiUrl(),
              params: cfg ? cfg.params : null
            }).then(function (response) {
              return response.data;
            });
          };
        }
        return [t.name, resource];
      }));
      _.extend(self, {
        reportLoaded: function reportLoaded(timeElapsed) {
          $http({
            method: 'POST',
            url: Api.url("activity/report-loaded"),
            headers: {
              'Content-Type': 'application/json'
            },
            data: timeElapsed
          });
        }
      });
      return self;
    };
  }]);
})();
